import {HttpCreateProjectNotesOptions, httpCreateProjectNotes} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreProjectNotes = (
    urlParams: HttpCreateProjectNotesOptions['urlParams'],
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpCreateProjectNotesOptions['payload']>
) => {
    return useMutation({
        ...options,
        mutationFn: payload =>
            httpCreateProjectNotes({
                urlParams,
                payload
            })
    })
}
